import script from "./VirtualMap.vue?vue&type=script&lang=ts&setup=true"
export * from "./VirtualMap.vue?vue&type=script&lang=ts&setup=true"

import "./VirtualMap.vue?vue&type=style&index=0&id=a4ee941a&lang=css"

const __exports__ = script;

export default __exports__